module.exports = __webpack_public_path__ + "media/i_love_you.c31b769e.webm";